import React from "react";
import {Widgets} from "./widgets/Widgets";
import {PeriodicSummaryHeader} from "./PeriodicSummaryHeader";
import {Helmet} from "react-helmet";
import {useTranslation} from "react-i18next";
import {WidgetsSkeleton} from "./WidgetsSkeleton";
import {useSelector} from "react-redux";

export const Statistics = () => {
    const {t} = useTranslation();
    const {isLoading: isRestaurantLoading} = useSelector((state) => state.dashboard.getRestaurant);

    return (
        <div className={'statistics-content'}>
            <Helmet>
                <title>{t('dashboard')} - {t('statistics')}</title>
            </Helmet>
            <PeriodicSummaryHeader/>
            {isRestaurantLoading ? <WidgetsSkeleton/> : <Widgets/>}
        </div>
    );
}